import React, { useState, useEffect } from "react";
import TextInput from "../library/TextInput";
import PaginatedTable from "../library/Pagination";
import API_BASE_URL from "../../config/api";

const HealthCondition = ({ userId }) => {
  const [rows, setRows] = useState([]);
  const [notification, setNotification] = useState(null);

  const [generalMaster, setGeneralMaster] = useState([]);

  useEffect(() => {

    const fetchgeneralMaster = async () => {
      const res = await fetch(`${API_BASE_URL}/api/Config/AllGeneralMaster`, {

      });
      if (res.ok) {
        const data = await res.json();
        setGeneralMaster(data);
      }
    };
    fetchgeneralMaster();

  }, []);

  const fetchData = () => {
    fetch(`${API_BASE_URL}/api/HealthCondition/employee/${userId}`)
      .then((res) => res.json())
      .then(setRows)
      .catch(console.error);
  };

  useEffect(fetchData, [userId]);

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  const handleEditToggle = async (index) => {
    const updated = [...rows];
    const row = updated[index];

    // If not in edit mode, just enable editing
    if (!row.isEditing) {
      updated[index].isEditing = true;
      setRows(updated);
      return;
    }

    // Validation
    if (!row.condition || !row.description) {
      setNotification({ type: "error", message: `Condition and Description are required.` });
      return;
    }

    // Prepare payload (only fields your API expects)
    const payload = {
      id: row.id || 0,
      condition: row.condition,
      description: row.description,
      status: row.status,
      startDate: row.startDate || null,
      endDate: row.endDate || null,
      employeeId: userId,
    };

    // Determine API method and URL
    const method = row.id ? "PUT" : "POST";
    const url = row.id
      ? `${API_BASE_URL}/api/HealthCondition/${row.id}`
      : `${API_BASE_URL}/api/HealthCondition`;

    try {
      const response = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("API Error:", response.status, errorText);
      } else {
        // Refresh data from backend after save
        fetchData();
        updated[index].isEditing = false; // Exit edit mode
        setRows(updated);
      }
    } catch (err) {
      console.error("Request failed:", err);
    }
  };


  const handleDelete = async (index) => {
    const row = rows[index];
    if (row.id)
      await fetch(`${API_BASE_URL}/api/HealthCondition/${row.id}`, {
        method: "DELETE",
      });
    setRows(rows.filter((_, i) => i !== index));
  };

  const handleAddRow = () => {
    setRows([...rows, { condition: "", description: "", status: "Existing", isEditing: true }]);
  };

  const closeNotification = () => setNotification(null);

  return (
    <div className="p-4">
      <h2 className="text-[#111518] text-[22px] font-bold leading-tight tracking-[-0.015em] pb-3">
        Health Conditions
      </h2>

      {notification && (
        <div
          className={`mb-4 p-4 rounded ${notification.type === "error"
            ? "bg-red-100 text-red-700"
            : "bg-green-100 text-green-700"
            }`}
        >
          <div className="flex justify-between items-center">
            <span>{notification.message}</span>
            <button onClick={closeNotification} className="font-bold text-xl leading-none">
              ×
            </button>
          </div>
        </div>
      )}

      <div className="px-4 py-3">
        <div className="flex overflow-hidden rounded-xl border border-[#dde1e3] bg-white">
          <PaginatedTable
            columns={[
              "Condition",
              "Description",
              "Status",
              "Action",
            ]}
            data={rows}
            pageSize={10}
            showPagination={false}
            renderRow={(row, index) => (
              <tr key={row.id || index} className="border-t border-t-[#dde1e3]">
                <td className="h-[72px] px-4 py-2 text-sm font-normal leading-normal">
                  <TextInput
                    value={row.condition}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) => handleChange(index, "condition", e.target.value)}
                  />
                </td>
                <td className="h-[72px] px-4 py-2 text-[#121516] text-sm font-normal leading-normal">
                  <TextInput
                    value={row.description}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) =>
                      handleChange(index, "description", e.target.value)
                    }
                  />
                </td>
                <td className="h-[72px] px-4 py-2 text-[#6a7881] text-sm font-normal leading-normal">
                  <select
                    value={row.status}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) =>
                      handleChange(index, "status", e.target.value)
                    }
                  >
                    {generalMaster.filter(x => x.mainId == 43 && x.isActive === true).map((opt) => (
                      <option key={opt.id} value={opt.id}>{opt.title}</option>
                    ))}
                  </select>
                </td>


                <td className="h-[72px] px-4 py-2 text-sm font-normal leading-normal">
                  <div className="flex gap-2">
                    <button
                      className="text-blue-600"
                      onClick={() => handleEditToggle(index)}
                    >
                      {row.isEditing ? "Save" : "Edit"}
                    </button>
                    <button
                      className="text-red-600"
                      onClick={() => handleDelete(index)}
                    >
                      Delete
                    </button>
                  </div>
                </td>

              </tr>
            )}
          />

        </div>
      </div>

      <div className="col-span-3 flex justify-end">
        <button
          className="btn-black"
          onClick={handleAddRow}
        >
          + Add Row
        </button>
      </div>

    </div>
  );
};

export default HealthCondition;
